export const states = [
  { label: "Andaman and Nicobar", value: "AN", pinStart: [74] },
  { label: "Andhra Pradesh", value: "AP", pinStart: [50, 51, 52, 53] },
  { label: "Arunachal Pradesh", value: "AR", pinStart: [79] },
  { label: "Assam", value: "AS", pinStart: [78] },
  { label: "Bihar", value: "BR", pinStart: [80, 81, 82, 83, 84, 85] },
  { label: "Chandigarh", value: "CG", pinStart: [16] },
  { label: "Chhattisgarh", value: "CH", pinStart: [45, 46, 47, 48, 49] },
  { label: "Dadra and Nagar Haveli", value: "DH", pinStart: [39] },
  { label: "Daman and Diu", value: "DD", pinStart: [36, 39] },
  { label: "Delhi", value: "DL", pinStart: [11] },
  { label: "Goa", value: "GA", pinStart: [40] },
  { label: "Gujarat", value: "GJ", pinStart: [36, 37, 38, 39] },
  { label: "Haryana", value: "HR", pinStart: [13] },
  { label: "Himachal Pradesh", value: "HP", pinStart: [17] },
  { label: "Jammu and Kashmir", value: "JK", pinStart: [18, 19] },
  { label: "Jharkhand", value: "JH", pinStart: [80, 81, 82, 83, 84, 85] },
  { label: "Karnataka", value: "KA", pinStart: [56, 57, 58, 59] },
  { label: "Kerala", value: "KL", pinStart: [67, 68, 69] },
  { label: "Ladakh", value: "LA", pinStart: [18, 19] },
  { label: "Lakshadweep", value: "LD", pinStart: [68] },
  { label: "Madhya Pradesh", value: "MP", pinStart: [45, 46, 47, 48, 49] },
  { label: "Maharashtra", value: "MH", pinStart: [40, 41, 42, 43, 44] },
  { label: "Manipur", value: "MN", pinStart: [79] },
  { label: "Meghalaya", value: "ML", pinStart: [79] },
  { label: "Mizoram", value: "MZ", pinStart: [79] },
  { label: "Nagaland", value: "NL", pinStart: [79] },
  { label: "Odisha", value: "OR", pinStart: [75, 76, 77] },
  { label: "Puducherry", value: "PY", pinStart: [60] },
  { label: "Punjab", value: "PB", pinStart: [14, 15, 16] },
  { label: "Rajasthan", value: "RJ", pinStart: [30, 31, 32, 33, 34] },
  { label: "Sikkim", value: "SK", pinStart: [73] },
  { label: "Tamil Nadu", value: "TN", pinStart: [60, 61, 62, 63, 64] },
  { label: "Telangana", value: "TS", pinStart: [50, 51, 52, 53] },
  { label: "Tripura", value: "TR", pinStart: [79] },
  {
    label: "Uttar Pradesh",
    value: "UP",
    pinStart: [20, 21, 22, 23, 24, 25, 26, 27, 28],
  },
  {
    label: "Uttarakhand",
    value: "UK",
    pinStart: [20, 21, 22, 23, 24, 25, 26, 27, 28],
  },
  {
    label: "West Bengal",
    value: "WB",
    pinStart: [70, 71, 72, 73, 74],
  },
];

/**
 * This the Case Life cycle for CLaimant
 */
export const AWAITING_RESPONDANT = "awaitingRespondant";
export const RESPONDANT_ONBOARDED = "respondantOnboarded";
export const AWAITING_RESPONDANT_QUIT = "caseclosedByCaseManager";
export const awaitingRespondentAcceptance = "awaitingRespondentAcceptance";

export const CLAIMENT_STR = "claimant";

/* addition Case Lifecycle status change */

export const ARBITRATION_REFERENCE = "arbitrationReference";
export const NOTICE_TO_ARBITRATE = "noticeToArbitrate";
export const APPOINTMENT_OF_ARBITRATOR = "appointmentOfArbitrator";
export const ACCEPTANCE_BY_ARBITRATOR = "acceptanceByArbitrator";
export const FIRST_NOTICE_FIRST_HEARING_INTIMATION = "firstHearingIntimation";
export const FILING_STATEMENT_OF_CLAIM = "filingStatementofClaim";
export const FILING_OF_SECTION_SEVENTEEN = "filingofSection17";
export const SECTION_SEVENTEEN_ORDER_PASSED = "section17OrderPassed";
export const FILING_OF_STATEMENT_OF_DEFENCE = "filingofStatementofDefence";
export const CROSSEXAMINATION_CLAIMANT_WITNESS =
  "crossExaminationClaimantWitness";
export const CROSSEXAMINATION_RESPONDENT_WITNESS =
  "crossExaminationRespondentWitness";
export const ARGUMENT = "arguments";

/**
 * @description Sub Stages
 */

export const DRAFT = "draft";
export const PENDING_REGISTRATION_FEE = "pendingRegistrationFee";
export const WAITING_FOR_CASE_APPROVAL = "waitingForCaseApproval";
export const AWAITING_RESPONDANT_CASE_ACCEPTANCE =
  "awaitingRespondentAcceptance";
export const WAITING_FOR_ARBITRATION_CONFIRMATION =
  "waitingForArbitratorConfirmation";
export const NEGOTIATION_ONGOING = "negotiationOngoing";
export const NEGOTIATION_REACHED = "negotiationReached";
export const CLAIMENT_PAID_NEGOTIATION = "claimantPaidNegotiationSuccessFee";
export const RESPONDENT_PAID_NEGOTIATION =
  "respondentPaidNegotiationSuccessFee";
export const BOTH_PAID_NEGOTIATION = "bothPaidNegotiationSuccessFee";
export const NEGOTIATION_QUIT_BY_CLAIMENT = "quitByClaimant";
export const NEGOTIATION_QUIT_BY_CASEMANAGER = "closedByCaseManager";
export const NEGOTIATION_QUIT_BY_RESPONDENT = "quitByRespondent";
export const ARBITRATION_NOMINATED = "arbitrationNominated";
export const ARBITRATION_CONFIRMED = "arbitrationConfirmed";
export const FIRST_NOTICE_SENT = "firstNoticeSent";
export const STATEMENT_OF_CLAIM_FILED = "statementOfClaimFiled";
export const AWAITING_FOR_SEC_SEVENTEEN_DETAILS = "awaitingForSec17Details";
export const SECTION_SEVENTEEN_PETITION_FILED = "sec17PetitionFiled";
export const SECTION_SEVENTEEN_ORDERED = "sec17Ordered";
export const AWAITING_SECTION_SEVENTEEN_EXECUTION = "awaitingSec17Execution";
export const SECTION_SEVENTEEN_EXTENSION_MEMO_FILED = "sec17ExtensionMemoFiled";
export const SECTION_SEVENTEEN_EXTENSION_MEMO_ORDERED =
  "sec17ExtensionMemoOrdered";
export const FS_ORDERED = "fsOrdered";
export const ATTACHMENT_ORDERED = "attachmentOrdered";
export const GARNISHEE_PROHIBITARY_ORDER = "garnisheeProhibitaryOrder";
export const GARNISHEE_FINAL_ORDER = "garnisheeFinalOrder";
export const SECTION_SEVENTEEN_CLOSED = "sec17Closed";
export const STATEMENT_OF_DEFENCE_FILED = "statementOfDefenceFiled";
export const REJOINDER_FROM_CLAIMNT = "rejoinderfromClaimant";
export const SURREJOINDER_FROM_RESPONDENT = "surrejoinderFromRespondent";
export const SECOND_NOTICE_MOM = "2ndNoticeMOM";
export const EVIDENCE_FILLED_BY_CLAIMANT = "evidenceFiledByClaimant";
export const EVIDENCE_FILLED_BY_RESPONDENT = "evidenceFiledByRespondent";
export const CROSS_EXAMINATION = "crossExamination";
export const ARGUMENTS_BY_CLAIMANT = "argumentsByClaimant";
export const ARGUMENTS_BY_RESPONDENT = "argumentsByRespondent";
export const RESERVED_FOR_AWARD = "reservedForAward";
export const AWARD_PASSED = "awardPassed";
export const RESOLUTION_FAILED = "resolutionFailed";
export const SETTLED_AND_WITHDRAWN = "settledAndWithdrawn";
export const UPDATED_AND_WITHDRAWN = "updatedAndWithdrawn";
export const FIRST_HEARING = "firstHearing";
export const SECOND_HEARING = "secondHearing";
export const THIRD_HEARING = "thirdHearing";
export const FIRST_MOM = "firstMom";
export const COMMENCEMENT_LETTER = "commencementLetter";
export const REFERENCE_LETTER = "referenceLetter";
export const ARBITRATION_INPROGRESS = "arbitrationInprogress";

const ctaConfigs = {
  reopenCase: [
    {
      type: "REOPEN_CASE",
      label: "Reopen Case",
      displayBtn: true,
      danger: false,
    },
  ],
  moveToAgreement: [
    {
      type: "MOVE_TO_AGREEMENT",
      label: "Go to Agreement",
      displayBtn: true,
    },
  ],
  none: [],
};

const baseStageConfig = (
  label,
  key,
  index,
  status = label,
  cta = ctaConfigs.none
) => ({
  label,
  key,
  index,
  enableSelection: false,
  status,
  cta,
});

/**This variable is use for CLaimant life cycle */
export const CLAIMANT_LIFE_CYCLE = [
  // Awaiting Respondent Stages
  ...[
    { key: AWAITING_RESPONDANT, label: "Awaiting Respondent onboarding" },
    {
      key: awaitingRespondentAcceptance,
      label: "Awaiting Respondent onboarding",
    },
    { key: AWAITING_RESPONDANT_QUIT, label: "Awaiting Respondent onboarding" },
  ].map(({ key, label }) => baseStageConfig(label, key, 1)),

  // Case Accepted/Preparation
  baseStageConfig("Case Accepted/Preparation", RESPONDANT_ONBOARDED, 2),

  // Negotiation Ongoing Stages
  ...[
    { key: NEGOTIATION_ONGOING, label: "Negotiation Ongoing" },
    {
      key: NEGOTIATION_QUIT_BY_CLAIMENT,
      label: "Negotiation Ongoing",
      cta: ctaConfigs.reopenCase,
    },
    {
      key: NEGOTIATION_QUIT_BY_RESPONDENT,
      label: "Negotiation Ongoing",
      cta: ctaConfigs.reopenCase,
    },
    {
      key: NEGOTIATION_QUIT_BY_CASEMANAGER,
      label: "Negotiation Ongoing",
      cta: ctaConfigs.reopenCase,
    },
  ].map(({ key, label, cta = ctaConfigs.none }) =>
    baseStageConfig(label, key, 3, label, cta)
  ),

  // Negotiation Concluded
  baseStageConfig("Negotiation Concluded", NEGOTIATION_REACHED, 4),

  // Agreement Stages
  ...[
    CLAIMENT_PAID_NEGOTIATION,
    BOTH_PAID_NEGOTIATION,
    RESPONDENT_PAID_NEGOTIATION,
  ].map((key) => baseStageConfig("Agreement", key, 5)),

  // Arbitration Stages
  ...[
    { key: ARBITRATION_REFERENCE, label: "Arbitration Reference" },
    { key: NOTICE_TO_ARBITRATE, label: "Notice To Arbitrate" },
    { key: APPOINTMENT_OF_ARBITRATOR, label: "Appointment To Arbitrator" },
    { key: ACCEPTANCE_BY_ARBITRATOR, label: "Acceptance by Arbitrator" },
    {
      key: FIRST_NOTICE_FIRST_HEARING_INTIMATION,
      label: "1st Notice (First Hearing Intimation)",
    },
    { key: FILING_STATEMENT_OF_CLAIM, label: "Filing Statement of Claim" },
    { key: FILING_OF_SECTION_SEVENTEEN, label: "Filing of Section 17" },
    { key: SECTION_SEVENTEEN_ORDER_PASSED, label: "Section 17 Order Passed" },
    {
      key: FILING_OF_STATEMENT_OF_DEFENCE,
      label: "Filing of Statement of Defence",
    },
    { key: REJOINDER_FROM_CLAIMNT, label: "Rejoinder from Claimant" },
    {
      key: SURREJOINDER_FROM_RESPONDENT,
      label: "Surrejoinder from Respondent",
    },
    { key: SECOND_NOTICE_MOM, label: "2nd Notice (MOM)" },
    {
      key: CROSSEXAMINATION_CLAIMANT_WITNESS,
      label: "Cross Examination - Claimant Witness",
    },
    {
      key: CROSSEXAMINATION_RESPONDENT_WITNESS,
      label: "Cross Examination - Respondent Witness",
    },
    { key: ARGUMENT, label: "Arguments" },
    { key: RESERVED_FOR_AWARD, label: "Reserved for Award" },
  ].map(({ key, label }) => baseStageConfig(label, key, 4)),
];

/**
 * This is the Case Life cycle for Respontent
 */
export const RESPONTANT_LIFE_CYCLE = [
  // Negotiation Ongoing Stages
  ...[
    { key: NEGOTIATION_ONGOING, label: "Negotiation Ongoing" },
    { key: NEGOTIATION_QUIT_BY_RESPONDENT, label: "Negotiation Ongoing" },
    { key: NEGOTIATION_QUIT_BY_CASEMANAGER, label: "Negotiation Ongoing" },
    { key: NEGOTIATION_QUIT_BY_CLAIMENT, label: "Negotiation Ongoing" },
  ].map(({ key, label }) => baseStageConfig(label, key, 1)),

  // Negotiation Concluded
  baseStageConfig(
    "Negotiation Concluded",
    NEGOTIATION_REACHED,
    2,
    "Negotiation Concluded",
    ctaConfigs.moveToAgreement
  ),

  // Agreement Stages
  ...[
    CLAIMENT_PAID_NEGOTIATION,
    BOTH_PAID_NEGOTIATION,
    RESPONDENT_PAID_NEGOTIATION,
  ].map((key) => baseStageConfig("Agreement", key, 3)),
];

export const SplitAudioMinutes = [
  { label: "Select Duration", value: "", disabled: true },
  { label: "15 Minutes", value: "15" },
  { label: "30 Minutes", value: "30" },
  { label: "45 Minutes", value: "45" },
  { label: "60 Minutes", value: "60" },
  { label: "75 Minutes", value: "75" },
  { label: "90 Minutes", value: "90" },
  { label: "120 Minutes", value: "120" },
];

export const TimeBuffer = [
  { label: "Select Buffer", value: "", disabled: true },
  { label: "0", value: 0 },
  {
    label: "200 ms",
    value: "200",
  },
  { label: "300 ms", value: "300" },
  { label: "500 ms", value: "500" },
];

export const SettingsDuration = [
  { label: "Select Duration", value: "", disabled: true },
  {
    label: "2 Seconds",
    value: "0.03333333333333333333",
  },
  {
    label: "5 Seconds",
    value: "0.08333333333333333",
  },
  {
    label: "10 Seconds",
    value: "0.17",
  },
  {
    label: "12 Seconds",
    value: "0.2",
  },
  {
    label: "15 Seconds",
    value: "0.25",
  },
  {
    label: "30 Seconds",
    value: "0.5",
  },
  {
    label: "1 Minute",
    value: "1",
  },
  {
    label: "2 Minutes",
    value: "2",
  },
  { label: "3 Minutes", value: "3" },
  { label: "5 Minutes", value: "5" },
];

export const TranscriptBuffer = [
  { label: "Select Transcript Buffer", value: "", disabled: true },
  {
    label: "10 Seconds",
    value: "10",
  },
  { label: "20 Seconds", value: "20" },
  { label: "30 Seconds", value: "30" },
];

export const ModelType = [
  { label: "Select Model Type", value: "", disabled: true },
  { label: "Tiny", value: "tiny" },
  { label: "Tiny_EN", value: "tiny.en" },
  {
    label: "Base",
    value: "base",
  },
  {
    label: "Base_EN",
    value: "base.en",
  },
  { label: "Small", value: "small" },
  { label: "Small_EN", value: "small.en" },
  { label: "Medium", value: "medium" },
  { label: "Medium_EN", value: "medium.en" },
  { label: "Large", value: "large" },
];

export const TextType = [
  { label: "Select Type", value: "", disabled: true },
  {
    label: "Question",
    value: "Question",
  },
  { label: "Answer", value: "Answer" },
  { label: "Statement", value: "Statement" },
  { label: "Order", value: "Order" },
];

export const deepgram_modal_type = [
  { label: "Nova-2", value: "nova-2" },
  { label: "Nova-3", value: "nova-3" },
  { label: "Nova-2-General", value: "nova-2-general" },
  { label: "Nova-2-Meeting", value: "nova-2-meeting" },
  { label: "Nova-2-Phonecall", value: "nova-2-phonecall" },
  { label: "Nova-2-Finance", value: "nova-2-finance" },
  { label: "Nova-2-Conversationalai", value: "nova-2-conversationalai" },
  { label: "Nova-2-Voicemail", value: "nova-2-voicemail" },
  { label: "Nova-2-Video", value: "nova-2-video" },
  { label: "Nova-2-Medical", value: "nova-2-medical" },
  { label: "Nova-2-Drivethru", value: "nova-2-drivethru" },
  { label: "Nova-2-Automotive", value: "nova-2-automotive" },
  { label: "Nova", value: "nova" },
  { label: "Nova-General", value: "nova-general" },
  { label: "Nova-Phonecall", value: "nova-phonecall" },
  { label: "Nova-Medical", value: "nova-medical" },
  {
    label: "Enhanced or Enhanced-General",
    value: "enhanced or enhanced-general",
  },
  { label: "Enhanced-Meeting", value: "enhanced-meeting" },
  { label: "Enhanced-Phonecall", value: "enhanced-phonecall" },
  { label: "Enhanced-Finance", value: "enhanced-finance" },
  { label: "Base", value: "base" },
  { label: "Base-General", value: "base-general" },
  { label: "Base-Meeting", value: "base-meeting" },
  { label: "Base-Phonecall", value: "base-phonecall" },
  { label: "Base-Finance", value: "base-finance" },
  { label: "Base-Conversationalai", value: "base-conversationalai" },
  { label: "Base-Voicemail", value: "base-voicemail" },
  { label: "Base-Video", value: "base-video" },
  { label: "Whisper-Tiny", value: "whisper-tiny" },
  { label: "Whisper-Base", value: "whisper-base" },
  { label: "Whisper-Small", value: "whisper-small" },
  { label: "Whisper-Medium OR Whisper", value: "whisper-medium OR whisper" },
  { label: "Whisper-Large", value: "whisper-large" },
];

export const deepgram_redact = [
  { label: "PII", value: "pii" },
  { label: "PHI", value: "phi" },
  { label: "PCI", value: "pci" },
  { label: "Account Number", value: "account_number" },
  { label: "Age", value: "age" },
  { label: "date", value: "date" },
  { label: "Date Interval", value: "date_interval" },
  { label: "Dob", value: "dob" },
  { label: "Driver License", value: "driver_license" },
  { label: "Duration", value: "duration" },
  { label: "Email Address", value: "email_address" },
  { label: "Event", value: "event" },
  { label: "Filename", value: "filename" },
  { label: "Gender Sexuality", value: "gender_sexuality" },
  { label: "Healthcare Number", value: "healthcare_number" },
  { label: "Ip Address", value: "ip_address" },
  { label: "Language", value: "language" },
  { label: "Location", value: "location" },
  { label: "Location Address", value: "location_address" },
  { label: "Location City", value: "location_city" },
  { label: "Location Coordinate", value: "location_coordinate" },
  { label: "Location Country", value: "location_country" },
  { label: "Location State", value: "location_state" },
  { label: "Location Zip", value: "location_zip" },
  { label: "Marital Status", value: "marital_status" },
  { label: "Money", value: "money" },
  { label: "Name", value: "name" },
  { label: "Name Family", value: "name_family" },
  { label: "Name Given", value: "name_given" },
  { label: "Name Medical Professional", value: "name_medical_professional" },
  { label: "Numerical Pii", value: "numerical_pii" },
  { label: "Occupation", value: "occupation" },
  { label: "Organization", value: "organization" },
  {
    label: "Organization Medical Facility",
    value: "organization_medical_facility",
  },
  { label: "Origin", value: "origin" },
  { label: "Passport Number", value: "passport_number" },
  { label: "Password", value: "password" },
  { label: "Phone Number", value: "phone_number" },
  { label: "Physical Attribute", value: "physical_attribute" },
  { label: "Political Affiliation", value: "political_affiliation" },
  { label: "Ssn", value: "ssn" },
  { label: "Time", value: "time" },
  { label: "Url", value: "url" },
  { label: "Username", value: "username" },
  { label: "Vehicle Id", value: "vehicle_id" },
  { label: "Zodiac Sign", value: "zodiac_sign" },
  { label: "Blood Type", value: "blood_type" },
  { label: "Condition", value: "condition" },
  { label: "Dose", value: "dose" },
  { label: "Drug", value: "drug" },
  { label: "Injury", value: "injury" },
  { label: "Medical Process", value: "medical_process" },
  { label: "Credit Card", value: "credit_card" },
  { label: "Credit Card Expiration", value: "credit_card_expiration" },
  { label: "Cvv", value: "cvv" },
  { label: "Bank Account", value: "bank_account" },
  { label: "Routing Number", value: "routing_number" },
];

export const deepgram_language = [
  { label: "English", value: "en" },
  { label: "English-US", value: "en-US" },
  { label: "English-GB", value: "en-GB" },
  { label: "English-IN", value: "en-IN" },
  { label: "English-NZ", value: "en-NZ" },
  { label: "English-AU", value: "en-AU" },
  { label: "Bulgarian", value: "bg" },
  { label: "Catalan", value: "ca" },
  { label: "Czech", value: "cs" },
  { label: "Danish", value: "da" },
  { label: "Danish-da-DK", value: "da-DK" },
  { label: "Dutch", value: "nl" },
  { label: "Dutch-hi-Latn", value: "hi-Latn" },
  { label: "Estonian", value: "et" },
  { label: "Finnish", value: "fi" },
  { label: "Flemish", value: "nl" },
  { label: "French", value: "fr" },
  { label: "German", value: "de" },
  { label: "German (Switzerland)", value: "de" },
  { label: "Greek", value: "el" },
  { label: "Hindi", value: "hi" },
  { label: "Hungarian", value: "hu" },
  { label: "Indonesian", value: "id" },
  { label: "Italian", value: "it" },
  { label: "Japanese", value: "ja" },
  { label: "Korean", value: "ko" },
  { label: "Korean-KR", value: "ko-KR" },
  { label: "Latvian", value: "lv" },
  { label: "Lithuanian", value: "ms" },
  { label: "Malay", value: "en" },
  { label: "Norwegian", value: "no" },
  { label: "Polish", value: "pl" },
  { label: "Portuguese", value: "pt" },
  { label: "Portuguese-BR", value: "pt-BR" },
  { label: "Romanian", value: "ro" },
  { label: "Russian", value: "ru" },
  { label: "Slovak", value: "sk" },
  { label: "b", value: "es" },
  { label: "b-es-419", value: "es-419" },
  { label: "Swedish", value: "sv" },
  { label: "Swedish-sv-SE", value: "sv-SE" },
  { label: "Thai", value: "no" },
  { label: "Turkish", value: "tr" },
  { label: "Ukrainian", value: "uk" },
  { label: "Vietnamese", value: "vi" },
  { label: "Multi Language", value: "multi" },
];

export const LIFE_CYCLE = [
  /**
   *@description Mediation/Arbitration Initiated stages
   */

  {
    label: "Mediation/Arbitration Initiated",
    key: DRAFT,
    index: 1,
    enableSelection: false,
    text: "Draft",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Initiated",
    key: PENDING_REGISTRATION_FEE,
    index: 1,
    enableSelection: false,
    text: "Awaiting Payment",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Initiated",
    key: WAITING_FOR_CASE_APPROVAL,
    index: 1,
    enableSelection: false,
    text: "Waiting For Case Approval",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Initiated",
    key: AWAITING_RESPONDANT_CASE_ACCEPTANCE,
    index: 1,
    enableSelection: false,
    text: "Waiting for Respondent",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Initiated",
    key: NOTICE_TO_ARBITRATE,
    index: 1,
    enableSelection: false,
    text: "Notice to Arbitrate",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Initiated",
    key: ARBITRATION_REFERENCE,
    index: 1,
    enableSelection: false,
    text: "Arbitration Referenced",
    cta: [
      {
        type: "QUIT",
        label: "Close Case",
        danger: true,
        displayBtn: true,
      },
    ],
  },
  {
    label: "Mediation/Arbitration Initiated",
    key: ARBITRATION_NOMINATED,
    index: 1,
    enableSelection: false,
    text: "Arbitrator Nominated",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Initiated",
    key: ARBITRATION_CONFIRMED,
    index: 1,
    enableSelection: false,
    text: "Arbitrator Confirmed",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Initiated",
    key: WAITING_FOR_ARBITRATION_CONFIRMATION,
    index: 1,
    enableSelection: false,
    text: "Waiting for Arbitration Confirmation",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Initiated",
    key: COMMENCEMENT_LETTER,
    index: 1,
    enableSelection: false,
    text: "Commencement Letter",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Initiated",
    key: REFERENCE_LETTER,
    index: 1,
    enableSelection: false,
    text: "Reference Letter",
    cta: [],
  },

  /**
   *@description Mediation/Arbitration In Progress
   */

  {
    label: "Mediation/Arbitration In Progress",
    key: FIRST_NOTICE_SENT,
    index: 2,
    enableSelection: false,
    text: "First Notice Sent",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: STATEMENT_OF_CLAIM_FILED,
    index: 2,
    enableSelection: false,
    text: "Statement of Claim Filed",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: AWAITING_FOR_SEC_SEVENTEEN_DETAILS,
    index: 2,
    enableSelection: false,
    text: "Awaiting for Sec 17 details",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: SECTION_SEVENTEEN_PETITION_FILED,
    index: 2,
    enableSelection: false,
    text: "Sec 17 Petition Filed",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: SECTION_SEVENTEEN_ORDERED,
    index: 2,
    enableSelection: false,
    text: "Sec 17 Ordered",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: AWAITING_SECTION_SEVENTEEN_EXECUTION,
    index: 2,
    enableSelection: false,
    text: "Awaiting Sec 17 Execution",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: SECTION_SEVENTEEN_EXTENSION_MEMO_FILED,
    index: 2,
    enableSelection: false,
    text: "Sec 17 Extension Memo Filed",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: SECTION_SEVENTEEN_EXTENSION_MEMO_ORDERED,
    index: 2,
    enableSelection: false,
    text: "Sec 17 Extension Memo Ordered",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: FS_ORDERED,
    index: 2,
    enableSelection: false,
    text: "FS Ordered",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: ATTACHMENT_ORDERED,
    index: 2,
    enableSelection: false,
    text: "Attachment Ordered",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: GARNISHEE_PROHIBITARY_ORDER,
    index: 2,
    enableSelection: false,
    text: "Garnishee Prohibitary Order",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: GARNISHEE_FINAL_ORDER,
    index: 2,
    enableSelection: false,
    text: "Garnishee Final Order",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: SECTION_SEVENTEEN_CLOSED,
    index: 2,
    enableSelection: false,
    text: "Sec 17 Closed",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: STATEMENT_OF_DEFENCE_FILED,
    index: 2,
    enableSelection: false,
    text: "Statement of Defence Filed",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: REJOINDER_FROM_CLAIMNT,
    index: 2,
    enableSelection: false,
    text: "Rejoinder from Claimant",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: SURREJOINDER_FROM_RESPONDENT,
    index: 2,
    enableSelection: false,
    text: "Surrejoinder From Respondent",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: SECOND_NOTICE_MOM,
    index: 2,
    enableSelection: false,
    text: "2nd Notice MOM",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: EVIDENCE_FILLED_BY_CLAIMANT,
    index: 2,
    enableSelection: false,
    text: "Evidence Filed by Claimant",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: EVIDENCE_FILLED_BY_RESPONDENT,
    index: 2,
    enableSelection: false,
    text: "Evidence Filed by Respondent",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: CROSS_EXAMINATION,
    index: 2,
    enableSelection: false,
    text: "Cross Examination",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: ARGUMENTS_BY_CLAIMANT,
    index: 2,
    enableSelection: false,
    text: "Arguments by Claimant",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: ARGUMENTS_BY_RESPONDENT,
    index: 2,
    enableSelection: false,
    text: "Arguments by Respondent",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: NEGOTIATION_ONGOING,
    index: 2,
    enableSelection: false,
    text: "Under Resolution",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: FIRST_HEARING,
    index: 2,
    enableSelection: false,
    text: "1st Hearing",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: SECOND_HEARING,
    index: 2,
    enableSelection: false,
    text: "2nd Hearing",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: THIRD_HEARING,
    index: 2,
    enableSelection: false,
    text: "3rd Hearing",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: FIRST_MOM,
    index: 2,
    enableSelection: false,
    text: "1st MOM",
    cta: [],
  },
  {
    label: "Mediation/Arbitration In Progress",
    key: ARBITRATION_INPROGRESS,
    index: 2,
    enableSelection: false,
    text: "Arbitration Inprogress",
    cta: [],
  },

  /**
   * @description Mediation/Arbitration Completed
   */

  {
    label: "Mediation/Arbitration Completed",
    key: NEGOTIATION_REACHED,
    index: 3,
    enableSelection: false,
    text: "Negotiation Reached",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Completed",
    key: CLAIMENT_PAID_NEGOTIATION,
    index: 3,
    enableSelection: false,
    text: "Claimant paid Success Fee",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Completed",
    key: RESPONDENT_PAID_NEGOTIATION,
    index: 3,
    enableSelection: false,
    text: "Respondent paid Success Fee",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Completed",
    key: BOTH_PAID_NEGOTIATION,
    index: 3,
    enableSelection: false,
    text: "Both paid NegotiationFee",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Completed",
    key: RESERVED_FOR_AWARD,
    index: 3,
    enableSelection: false,
    text: "Reserved for Award",
    cta: [],
  },
  {
    label: "Mediation/Arbitration Completed",
    key: AWARD_PASSED,
    index: 3,
    enableSelection: false,
    text: "Award Passed",
    cta: [],
  },

  /**
   * @description Resolution Closed
   */

  {
    label: "Resolution Closed",
    key: NEGOTIATION_QUIT_BY_CLAIMENT,
    index: 4,
    enableSelection: false,
    text: "Quit by Claimant",
    cta: [
      {
        type: "REOPEN_CASE",
        label: "Reopen Case",
        displayBtn: true,
        danger: false,
      },
    ],
  },
  {
    label: "Resolution Closed",
    key: NEGOTIATION_QUIT_BY_RESPONDENT,
    index: 4,
    enableSelection: false,
    text: "Quit by Respondent",
    cta: [
      {
        type: "REOPEN_CASE",
        label: "Reopen Case",
        displayBtn: true,
        danger: false,
      },
    ],
  },
  {
    label: "Resolution Closed",
    key: RESOLUTION_FAILED,
    index: 4,
    enableSelection: false,
    text: "Resolution Failed",
    cta: [],
  },
  {
    label: "Resolution Closed",
    key: NEGOTIATION_QUIT_BY_CASEMANAGER,
    index: 4,
    enableSelection: false,
    text: "Closed By CaseManager",
    cta: [
      {
        type: "REOPEN_CASE",
        label: "Reopen Case",
        displayBtn: true,
        danger: false,
      },
    ],
  },
  {
    label: "Settled & Withdrawn",
    key: SETTLED_AND_WITHDRAWN,
    index: 4,
    enableSelection: false,
    text: "Settled & Withdrawn",
    cta: [],
  },
  {
    label: "Updated & Withdrawn",
    key: UPDATED_AND_WITHDRAWN,
    index: 4,
    enableSelection: false,
    text: "Updated & Withdrawn",
    cta: [],
  },
];
